import ButtonExportModel from '../components/PropertiesPaneButtonExportModel.jsx'
import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'
import ButtonImportProductsFromXls from '../_DESIGN/PropertiesPaneButtonImportProductsFromXls.jsx'
import ButtonCompleteFmCode from './PropertiesPaneButtonCompleteFmCode.jsx'
import ButtonGenerateBd from './PropertiesPaneButtonGenerateBd.jsx'
import ButtonGenerateFm from './PropertiesPaneButtonGenerateFm.jsx'

export default function PropertiesPaneFa(props) {
    return (
        <ArchPropertiesPane
            buttons={
                <>
                    <ButtonExportModel global type="bdlogic_excel" />

                    <ButtonImportProductsFromXls type="fm">
                        导入功能结构
                    </ButtonImportProductsFromXls>

                    <ButtonGenerateFm />
                    <ButtonGenerateBd />
                    <ButtonCompleteFmCode />
                </>
            }

            {...props}
        />
    )
}
